/**
 * Web storage key names. The server can set a prefix (`SSO_STORAGE_KEY_PREFIX`) and passes it
 * through the SSR payload; without it the legacy key names are kept.
 *
 * ⚠️ The blocking script in `index.html` reads the theme key too — keep the naming in sync.
 */
const prefix = typeof logtoSsr === 'object' ? logtoSsr.storageKeyPrefix : undefined;

export const themeStorageKey = prefix ? `${prefix}:theme` : 'tdx:theme';
export const logtoStorageKeyPrefix = prefix ?? 'logto';
export const languageStorageKey = prefix ? `${prefix}:ui-lng` : 'i18nextLogtoUiLng';
